/**
 * Tras POST nativo + CAPTCHA, Shopify redirige a return_to con ?customer_posted=true
 * y a veces #contact_form (ancla del form customer). No interceptamos el submit.
 *
 * Guardamos section.id en sessionStorage al enviar porque Shopify suele quitar
 * newsletter_section de la URL final.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'nr_success_section';

  function bindSubmitMark() {
    document.querySelectorAll('[data-newsletter-register-section] .newsletter-register-form').forEach(function (form) {
      if (form.getAttribute('data-nr-mark') === '1') return;
      form.setAttribute('data-nr-mark', '1');
      form.addEventListener('submit', function () {
        var wrap = form.closest('[data-newsletter-register-section]');
        if (!wrap) return;
        try {
          sessionStorage.setItem(STORAGE_KEY, wrap.getAttribute('data-newsletter-register-section'));
        } catch (e) {
          /* ignore */
        }
      });
    });
  }

  function activateFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('customer_posted')) return;

      var sectionIdFromUrl = params.get('newsletter_section');
      var storedId = null;
      try {
        storedId = sessionStorage.getItem(STORAGE_KEY);
      } catch (e) {
        /* ignore */
      }

      var targetId = sectionIdFromUrl || storedId;
      var wrappers = document.querySelectorAll('[data-newsletter-register-section]');

      function reveal(el) {
        if (!el) return;
        el.removeAttribute('hidden');
        el.removeAttribute('aria-hidden');
      }

      if (targetId) {
        wrappers.forEach(function (wrapper) {
          var sid = wrapper.getAttribute('data-newsletter-register-section');
          if (sid !== targetId) return;
          reveal(document.getElementById('NewsletterRegister-success--' + sid));
        });
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          /* ignore */
        }
      } else if (wrappers.length) {
        var sid0 = wrappers[0].getAttribute('data-newsletter-register-section');
        reveal(document.getElementById('NewsletterRegister-success--' + sid0));
      }

      var successShown = document.querySelector('.newsletter-register__success-message:not([hidden])');
      if (successShown) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            try {
              successShown.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (e) {
              /* ignore */
            }
          });
        });
      }

      params.delete('customer_posted');
      params.delete('newsletter_section');
      var qs = params.toString();
      var clean = window.location.pathname + (qs ? '?' + qs : '');
      window.history.replaceState({}, '', clean);
    } catch (e) {
      /* ignore */
    }
  }

  function init() {
    bindSubmitMark();
    activateFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
